import React from 'react';
import classNames from 'classnames';
import './index.less';

export interface IABSBadgeProps {
  count?: number;
  children: React.ReactNode;
  offset?: [number, number];
  isVisibility?: boolean;
  className?: string;
}

export default class ABSBadge extends React.Component<IABSBadgeProps, any> {
  public render() {
    const {count, children, offset, isVisibility, className} = this.props;
    const classes = classNames('abs-badge', className);
    const reddotClass = classNames('abs-reddot', 
      {'abs-reddot-position': offset}, 
      {'hidden': !count && !isVisibility},
      {'visibility-hidden': !count && isVisibility}
      );
    const reddotStyle = offset && Array.isArray(offset) ? {top: offset[0] || 0, right: offset[1] || 0} : undefined;
    return (
      <div className={classes}>
        <div className={reddotClass} style={reddotStyle} />
        <div className="abs-badge-children">{children}</div>
        {(count && count > 0) ? <span>（{count}）</span> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSBadge/index.tsx